export const settingInput = (InputData, configType) => {
	let returnValue = ''
	InputData.filter(data => data.configType == configType).map(values => {
		if(values.typeValue == 'file'){
			if(values.file){
				if(values.file.fileMimeType.includes("application") ){
					returnValue = createFileBlob(values.file.fileId)
					// returnValue = 'data:'+values.file.fileMimeType+';base64,'+values.file.fileId
				}else{
					returnValue = 'data:'+values.file.fileMimeType+';base64,'+values.file.fileId
				}
			}else{
				returnValue = null
			}
		}else{
			returnValue = values.configValue1
		}
	})

	return returnValue
}

export const urlLinkFile = (values) => {
	console.log('values',values)
	let returnValue = ''
	if(values){
		if(values.fileMimeType.includes("application") ){
			returnValue = createFileBlob(values.fileId)
			// returnValue = 'data:'+values.file.fileMimeType+';base64,'+values.file.fileId
		}else{
			returnValue = 'data:'+values.fileMimeType+';base64,'+values.fileId
		}
	}else{
		returnValue = null
	}

	return returnValue
}

const base64ToBlob = (base64, type = "application/octet-stream" ) => {
	const binStr = atob( base64 );
	const len = binStr.length;
	const arr = new Uint8Array(len);
	for (let i = 0; i < len; i++) {
	  arr[ i ] = binStr.charCodeAt( i );
	}
	return new Blob( [ arr ], { type: type } );
}

const createFileBlob = (file) =>{

	const blob = base64ToBlob( file, 'application/pdf' );
	const url = URL.createObjectURL( blob );
	return url
}